import { useState } from "react";
import { X, Hash } from "lucide-react";
import { ChannelSelect } from "@/components/ChannelSelect";

const MODES = [
  { v: "all", label: "All channels" },
  { v: "allow", label: "Only these channels" },
  { v: "block", label: "Everywhere except these" },
];

export const DmChannelLimits = ({ guildId, d, setD }) => {
  const [pick, setPick] = useState("");
  const mode = d.dm_channel_mode || "all";
  const chans = d.dm_channels || [];
  const add = (name) => {
    const n = (name || "").trim().replace(/^#/, "");
    if (n && !chans.includes(n) && chans.length < 25) setD({ ...d, dm_channels: [...chans, n] });
    setPick("");
  };
  return (
    <div data-testid="dm-channel-limits" className="mt-4">
      <span className="text-xs uppercase tracking-wider text-zinc-500">Where the trigger works</span>
      <div className="mt-1.5 flex flex-wrap gap-1.5">
        {MODES.map((m) => (
          <button key={m.v} type="button" data-testid={`dm-channel-mode-${m.v}`} onClick={() => setD({ ...d, dm_channel_mode: m.v })}
            className={`text-xs rounded-full px-3 py-1 border transition-colors ${mode === m.v ? "bg-volt text-black border-volt" : "border-zinc-700 text-zinc-300 hover:border-zinc-500"}`}>
            {m.label}
          </button>
        ))}
      </div>
      {mode !== "all" && (
        <div className="mt-3">
          <div className="flex flex-wrap gap-1.5 mb-2" data-testid="dm-channel-list">
            {chans.length === 0 && <span className="text-xs text-amber-400">{mode === "allow" ? "Add at least one channel — otherwise the trigger works nowhere." : "No channels blocked yet."}</span>}
            {chans.map((c) => (
              <span key={c} data-testid={`dm-channel-chip-${c}`} className="inline-flex items-center gap-1 text-xs bg-zinc-800 rounded-md pl-2 pr-1 py-1">
                <Hash className="w-3 h-3 text-zinc-500" />{c}
                <button type="button" data-testid={`dm-channel-remove-${c}`} onClick={() => setD({ ...d, dm_channels: chans.filter((x) => x !== c) })} className="text-zinc-500 hover:text-red-400"><X className="w-3 h-3" /></button>
              </span>
            ))}
          </div>
          <div className="flex items-center gap-2 max-w-sm">
            <ChannelSelect guildId={guildId} value={pick} onChange={setPick} testid="dm-channel-pick" placeholder="— pick a channel —" className="!mt-0" />
            <button type="button" data-testid="dm-channel-add" disabled={!pick.trim() || chans.length >= 25} onClick={() => add(pick)}
              className="shrink-0 bg-zinc-800 hover:bg-zinc-700 disabled:opacity-40 rounded-md px-3 py-2 text-sm transition-colors">Add</button>
          </div>
          <p className="text-[11px] text-zinc-500 mt-1.5">Threads follow their parent channel. Applies to the @mention trigger too. {chans.length}/25</p>
        </div>
      )}
    </div>
  );
};
